<template>
  <div>
    <Loading v-show="loading" />
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import Menu from "@/components/modules/adm/login/Menu.js";

import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "LoginTemView",
  components: { Loading },
  data() {
    return {
      menu: new Menu(),
      urlLogin: "api/v1/adm/auth/login",
      username: this.$route.params.username,
      password: this.$route.params.password,
      loading: true,
    };
  },
  mounted() {
    this.sigin();
  },
  computed: {
    ...mapState("user", ["userLogged"]),
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("user", ["addUserLogged", "addItemMenu", "removeItemMenu"]),
    sigin() {

      var username = this.desembaralhar(this.username, "NixlocKey");
      var password = this.desembaralhar(this.password, "NixlocKey");

      let params = { url: this.urlLogin, obj: { username: username, password: password } };
      this.postApi(params).then((response) => {
        if (response.success) {
          this.addUserLogged(response.content);
          this.loadMenu();
          this.$router.replace(this.$route.query.redirect || "/dashboard");
        }
      });
    },
    loadMenu() {
      this.removeItemMenu();
      let self = this;
      this.userLogged.user.rules.forEach(function (rule) {
        self.hasRule(rule);
      });
    },
    hasRule(rule) {
      let self = this;
      this.menu.itens.forEach(function (item) {
        if (rule.name === item.rule) self.addItemMenu([item]);
      });
    },
    desembaralhar(texto, chave) {
      texto = atob(texto);
      let result = "";
      for (let i = 0; i < texto.length; i++) {
        result += String.fromCharCode(
          texto.charCodeAt(i) ^ chave.charCodeAt(i % chave.length)
        );
      }
      return result;
    }
  },
};
</script>
